<template>
  <div class="n-async-container">
    <slot v-if="empty && !loading" name="empty">
      <div class="c-empty-container">
        <i class="far fa-hdd" />
        <template v-if="!blank">
          <span class="c-empty-label">{{ $tl('noDataFound') }}</span>
        </template>
      </div>
    </slot>
    <slot />
    <div v-if="loading" class="c-loading-container">
      <div class="c-loading-mask" />
      <div class="c-loading-content">
        <div>
          <slot name="loading">
            <i class="c-loading-icon fas fa-spinner n-spinner" />
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
/**
 * @Author Ken
 * @CreateDate 2021-12-13 18:39
 * @desc 设计目的: 统一loading与empty的效果
 * @params
 * @return
 */
const props = defineProps({
  loading: Boolean,
  empty: Boolean,
  blank: {
    type: Boolean,
    default: false,
  },
});
</script>

<script>
export default {
  name: 'NAsyncContainer',
};
</script>

<style lang="less">
.n-async-container {
  position: relative;
  min-height: 100px;

  .c-empty-container {
    position: absolute;
    width: 100%;
    height: 100%;
    border: 1px dotted #ccc;
    border-radius: 4px;
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #555;
    .c-empty-label {
      margin-left: 10px;
    }
  }

  .c-loading-container {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    .c-loading-mask {
      position: absolute;
      width: 100%;
      height: 100%;
      opacity: 0.7;
      background-color: white;
    }
    .c-loading-content {
      position: absolute;
      width: 100%;
      height: 100%;
      display: grid;
      gap: 10px;
      place-content: center;
      text-align: center;
      .c-loading-icon {
        font-size: 2rem;
        color: gray;
      }
    }
  }
}
</style>
